import { all } from 'redux-saga/effects';
import renewalConfigs from './renewalConfigs';

export default function* () {
    yield all([...renewalConfigs]);
}
